<template>
  <div class="shadow-lg p-4">
    <b-modal id="modal-6" hide-header ok-only @ok="redirect">
      <img
        src="@/assets/images/MicrosoftTeams-image (8).png"
        class="m-auto h-100px"
      />

      <p class="my-6 fsize25px text-black text-center">
        Your session has been confirmed
      </p>
      <div class="px-5 pb-6 mt-5 flex justify-between mx-auto flex-wrap">
        <div class="flex items-center">
          <p class="font-medium text-black mr-2">
            <b
              >Volunteer:{{ get_volbyid.userId.firstname }}
              {{ get_volbyid.userId.lastname }}</b
            >
          </p>
          <span></span>
        </div>
        <div class="flex items-center">
          <p class="font-medium text-black mr-2">
            <b>Date:{{ calendarData.selectedDate }}</b>
          </p>
          <span></span>
        </div>
        <div class="flex items-center">
          <p class="font-medium text-black mr-2">
            <b>Time: {{ selectedTime }}</b>
          </p>
          <span></span>
        </div>
      </div>
    </b-modal>
    <!-- <h3 class="fsize20 font-semibold">Home / Thane / Book Appointment</h3>-->
    <p class="fsize16 py-3 font-semibold text-primary">Select Date and Time</p>
    <functional-calendar
      v-model="calendarData"
      :change-month-function="true"
      :change-year-function="true"
      :sundayStart="true"
      @dayClicked="getDate"
      :is-date-range="false"
      :is-date-picker="true"
      ref="calendarData"
      :enabled-dates="enabledDates"
      :disabled-dates="disabledDay"
    >
    </functional-calendar>
    <div v-if="calendarData.selectedDate">
      <div class="text-xl mt-6 mb-2">
        <h1>Time</h1>
      </div>
      <template v-if="slots.length > 0">
        <b-form-checkbox
          :key="index"
          v-for="(item, index) in slots"
          button
          v-model="selectedTime"
          :value="item"
          size="md"
          button-variant="outline-primary"
          class="text-white mr-2 mb-2"
          >{{ item }}
        </b-form-checkbox>
      </template>
      <template v-else> No Slots available</template>
    </div>
    <div v-if="selectedTime">
      <b-button
        @click="handleOpenDetailModal('online')"
        variant="primary"
        class="mr-4 mt-4"
        >Book Now</b-button
      >

      <!-- <b-form-radio-group
        v-model="selected"
        :options="options"
        class="mb-6"
        value-field="item"
        text-field="name"
        fill
        disabled-field="notEnabled"
      ></b-form-radio-group> -->
    </div>
    <!-- mycode -->
    <!-- <div v-if="this.selected == 'Online'">
      <div
        v-for="(item, index) in profileData"
        :key="'item -' + index"
        :item="item"
      >
        <div v-if="selected">
          <p class="text-535353 font-extrabold fsize38px">
            Name - {{ get_volbyid.userId.firstname }}
            {{ get_volbyid.userId.lastname }}
          </p>
          <p class="text-535353 font-extrabold">
            Date -<span class="meet-clr">{{ calendarData.selectedDate }} </span>
          </p>
          <p class="text-535353 font-extrabold">
            Time -<span class="meet-clr">{{ selectedTime }} </span>
          </p>
          <p class="text-535353 font-extrabold">
            Email -<span class="meet-clr">{{ get_volbyid.userId.email }} </span>
          </p>
          <p class="text-535353 font-extrabold">
            Mobile -<span class="meet-clr"
              >{{ get_volbyid.userId.mobile }}
            </span>
          </p>
          <p class="text-535353 font-extrabold">
            Price -<span class="meet-clr">{{ get_volbyid.price }} </span>
          </p>

          <p class="text-center mt-4">
            Please connect your google account. This is where we'll share the
            meeting details with you.
          </p>
        </div>
      </div>
      <div v-b-modal.modal-2>
        <div class="flex justify-center mt-6">
          <b-button class="book-button">Book Session</b-button>
        </div>
      </div>
    </div> -->
    <div>
      <!-- <div
        v-for="(item, index) in profileData"
        :key="'item -' + index"
        :item="item"
      > -->
      <div v-if="selected">
        <!-- <b-button variant="primary" class="mr-4 mt-4" @click="getAuth()"
          >Google Auth</b-button
        > -->
        <!-- <b-button
          @click="handleOpenDetailModal"
          variant="primary"
          class="mr-4 mt-4"
          >Details</b-button
        > -->
        <b-modal id="modal-5" hide-footer title="Details">
          <CalenderPopUp
            :serviceType="selected"
            :date="calendarData"
            :time="selectedTime"
          />
        </b-modal>

        <!-- <p class="text-535353 font-extrabold fsize38px">
            Name - {{ get_volbyid.userId.firstname }}
            {{ get_volbyid.userId.lastname }}
          </p>
          <p class="text-535353 font-extrabold">
            Date -<span class="meet-clr">{{ calendarData.selectedDate }} </span>
          </p>
          <p class="text-535353 font-extrabold">
            Time -<span class="meet-clr">{{ selectedTime }} </span>
          </p>
          <p class="text-535353 font-extrabold">
            Mobile -<span class="meet-clr"
              >{{ get_volbyid.userId.mobile }}
            </span>
          </p>
          <p class="text-535353 font-extrabold">
            Address -<span class="meet-clr"
              >{{ item.address }} {{ item.city }}
            </span>
          </p>
          <p class="text-535353 font-extrabold">
            Price -<span class="meet-clr">{{ get_volbyid.price }} </span>
          </p> -->
      </div>
      <!-- </div> -->
      <!-- <div v-b-modal.modal-2>
        <div class="flex justify-center mt-6">
          <b-button
            class="book-button mr-4 mt-4"
            variant="primary"
            @click="InpersonSubmit()"
            >Book Session</b-button
          >
        </div>
      </div> -->
    </div>
    <!-- mycode -->

    <!-- <b-modal hide-header hide-footer id="modal-2">
      <img
        src="@/assets/images/MicrosoftTeams-image (8).png"
        class="m-auto h-100px"
      />

      <p class="my-6 fsize25px text-black text-center">
        Your session has been confirmed
      </p>
      <div class="px-5 pb-6 mt-5 flex justify-between mx-auto flex-wrap">
        <div class="flex items-center">
          <p class="font-medium text-black mr-2">
            <b
              >Volunteer: {{ get_volbyid.userId.firstname }}
              {{ get_volbyid.userId.lastname }}</b
            >
          </p>
          <span></span>
        </div>
        <div class="flex items-center">
          <p class="font-medium text-black mr-2">
            <b>Date: {{ calendarData.selectedDate }}</b>
          </p>
          <span></span>
        </div>
        <div class="flex items-center">
          <p class="font-medium text-black mr-2">
            <b>Time: {{ selectedTime }}</b>
          </p>
          <span></span>
        </div>
      </div>
    </b-modal> -->
  </div>
</template>
<script>
import { FunctionalCalendar } from "vue-functional-calendar";
import { mapState } from "vuex";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import CalenderPopUp from "./CalenderPopUp.vue";
import Swal from "sweetalert2";

export default {
  components: {
    FunctionalCalendar,
    CalenderPopUp,
  },
  data() {
    return {
      selected: "A",

      enabledDates: [],
      disabledDay: ["beforeToday"],
      options: [
        { item: "online", name: "Online" },
        { item: "inperson", name: "In-person" },
      ],
      calendar: {},
      calendarData: {},

      calendarConfigs: {
        sundayStart: false,
        dateFormat: "dd-mm-yyyy",
        isDatePicker: true,
        isDateRange: true,
      },
      slots: [
        // "11:00am",
        // "01:30pm",
        // "04:00pm",
        // "07:15pm",
        // "08:00pm",
        // "08:15pm",
        // "09:30pm",
      ],
      defaultSlots: [
        "10:00am",
        "11:00am",
        "12:00pm",
        "01:00pm",
        "02:00pm",
        "03:00pm",
        "04:00pm",
        "05:00pm",
        "06:00pm",
      ],
      selectedTime: "",
      selected: "",
      // getDate: {},
      selectdata: {},
      summary: "",
      price: "",
      isGoogleSigned: "",
      sessionDateTime: "",
      // calendarConfigs: {
      //   // disabledDates: ["beforeToday"],
      //   // enabledDates: ["afterToday"],
      // },
      meetLink: "",
      s2: [],
    };
  },
  methods: {
    async getAuth() {
      try {
        let res = await this.$store.dispatch("google/getAuthUrl", {
          redirectURL: this.$webURL + "/schedule-page",
          scopes: [
            "https://www.googleapis.com/auth/calendar",
            "https://www.googleapis.com/auth/calendar.events",
          ],
        });
        // console.log(this.$webURL + "/schedule-page", "Window location href");
        window.open(res.data, "_self");
      } catch (error) {
        console.log(error);
      }
    },
    handleOpenDetailModal(val) {
      if (this.$route.query.code) {
        // this.selected = "online";
        this.handleClick();
        // this.onSuccessPayment();
      } else {
        this.$bvModal.show("modal-5");
      }
    },
    getDate(val) {
      console.log(val);
      if (val.isMarked) {
        return false;
      }
      this.slots = [];
      if (this.get_volbyid.hasOwnProperty("dateTimeSlots")) {
        if (this.get_volbyid.dateTimeSlots.hasOwnProperty("types")) {
        } else {
          let timeFound = this.get_volbyid.dateTimeSlots.find(
            (ele) => ele.date == val.date
          );
          if (timeFound) {
            if (val.isToday) {
              timeFound.time.forEach((ele) => {
                if (
                  new Date().getHours() <
                  parseInt(this.convertTime(ele).slice(0, 3))
                ) {
                  this.slots.push(ele);
                }
              });
            } else {
              this.slots = timeFound.time;
            }
          }
        }
      }
    },
    convertTime(time12h) {
      const time = time12h.match(/(\d{2}):(\d{2})(\w{2})/).slice(1, 4);
      const modifier = time12h.slice(5);
      let hours = parseInt(time12h.slice(0, 2));
      let minute = time12h.slice(3, 5);
      if (hours === 12) {
        hours = 0;
      }
      if (modifier === "pm") {
        hours += 12;
      }
      return `${hours.toString().padStart(2, "0")}:${minute}`;
    },
    async handleClick() {
      let self = this;
      var amount = Number(this.sessionPrice) * 100;
      let d = this.calendarData.selectedDate.split("/");
      var paymentRecord = async (response) => {
        var responcenew = await this.handlePaymentRecord(response);
        this.currTransactionId = responcenew.data._id;

        if (responcenew) {
          const payload = {
            "paymentInfo.paymentAmt": parseInt(Number(this.sessionPrice)),
            "paymentInfo.transactionId": responcenew.data._id,
            "paymentInfo.invoiceId": responcenew.data.orderId,
            "paymentInfo.paymentStatus": "success",

            session: this.selected,
            date: new Date(parseInt(d[2]), parseInt(d[1]), parseInt(d[0])),
            time: this.selectedTime,
            summary: this.summary,
            userId: this.user._id,
            volunteerId: this.get_volbyid._id,
            price: this.sessionPrice,
            // city: this.city,
            // pincode: isNaN(this.pincode) ? null : parseInt(this.pincode),
            // state: this.selectstate,
            // address: this.address,
          };
          // console.log(payload);
          try {
            const data = await this.$store.dispatch(
              "respitecare/createbooking",
              payload
            );

            if (data.code == 200) {
              let TransPayload = {
                _id: responcenew.data._id,
                transactionstatus: "Success",
              };

              await this.$store.dispatch(
                "transaction/UpdateTransaction",
                TransPayload
              );

              // loader.close();
              // console.log("payment success");
              this.onlineSubmit();

              const status = await this.$store.dispatch(
                "respitecare/editbooking",
                {
                  _id: data.data._id,
                  orderStatus: "success",
                  // meetLink: this.meetLink,
                }
              );
              // console.log(object);
              if (status.code == 200) {
                this.$swal.fire({
                  title: "Order Placed!",
                  text: "Your order has been placed Successfully!",
                  icon: "success",
                  showConfirmButton: false,
                  showCancelButton: false,
                  timer: 2000,
                });
                await this.onSuccessPayment();
              } else if (status.code == 401) {
                this.$router.push({ name: "signin" });
                this.$swal.fire({
                  title: "Session Expired",
                  text: "Your session has ended and for security reasons, we request you to login again",
                  icon: "warning",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              }
            }
            // loader.close();
          } catch (error) {
            // loader.close();
            console.log(error);
          }
        }
      };
      this.$store
        .dispatch("payment/CreateOrderPayment", {
          amount: Number(Math.round(amount)),
        })
        .then(async (_) => {
          console.log(_);
          if (Object.keys(_.data).length == 0) {
            // console.log("Payment failed");
            return;
          }
          var options = {
            key: process.env.RAZORPAY_KEY_ID,
            amount: _.data.amount.toString(),
            currency: "INR",
            name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
            description: `Session Booking `,
            order_id: _.data.id,
            handler: function (response) {
              paymentRecord(response);
            },
            prefill: {
              name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
              email: `${this.user.email || ""}`,
              phone: `${this.user.mobile || ""}`,
            },
          };
          var rzp1 = new Razorpay(options);
          rzp1.on("payment.failed", async function (response) {
            // console.log("FAILEDTRANSACTION");
            self.handleFaliedTransaction();
          });
          rzp1.open();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async handlePaymentRecord(responce) {
      try {
        let payload = {
          transactionId: responce.razorpay_signature,
          transactionstatus: "In-Progress",
          transactionMode: "online",
          orderId: responce.razorpay_order_id,
          razorpayKey: {
            razorpay_payment_id: responce.razorpay_payment_id,
            razorpay_order_id: responce.razorpay_order_id,
            razorpay_signature: responce.razorpay_signature,
          },
        };
        const transactionrecord = await this.$store.dispatch(
          "transaction/CreateTransaction",
          payload
        );
        this.currTransactionId = transactionrecord.data._id;
        return transactionrecord;
      } catch (err) {
        console.log(err);
      }
    },
    async handleFaliedTransaction() {
      let TransPayload = {
        _id: this.currTransactionId,
        transactionstatus: "Failed",
      };
      let data = await this.$store.dispatch(
        "transaction/UpdateTransaction",
        TransPayload
      );
    },
    async onlineSubmit() {
      try {
        // this.calendarData = this.date;
        // console.log(this.date, this.calendarData, "this.date");
        let d = this.calendarData.selectedDate.split("/");
        let date2 = new Date(
          parseInt(d[2]),
          parseInt(d[1] - 1),
          parseInt(d[0])
        );
        let time = this.selectedTime.slice(0, 5) + ":00";
        if (this.selectedTime.includes("pm")) {
          let convert = time.split(":");
          convert[0] = Number(convert[0]) + 12;
          time = convert.join(":");
          this.sessionDateTime = new Date(
            `${date2.toString().slice(4, 15)} ${time}`
          );
        } else {
          this.sessionDateTime = new Date(
            `${date2.toString().slice(4, 15)} ${time}`
          );
        }
      } catch (error) {
        console.log(error);
      }
      // this.onSuccessPayment();
      return new Promise(async (resolve, reject) => {
        // console.log(this.googleAuth, "this.googleAuth");
        // let query = this.queries.map((x) => `<li>${x.query}</li>`);

        // let loader = this.$loading.show({});
        try {
          // await this.getAuth();
          await this.getToken(decodeURIComponent(this.$route.query.code));
          // console.log(this.googleAuth.access_token, " : Access Token");
          const { data } = await axios.post(
            "https://www.googleapis.com/calendar/v3/calendars/primary/events?conferenceDataVersion=1&maxAttendees=5&sendNotifications=true",
            {
              end: {
                dateTime: this.sessionDateTime,
              },
              start: {
                dateTime: this.sessionDateTime,
              },
              conferenceData: {
                createRequest: {
                  conferenceSolutionKey: {
                    type: "hangoutsMeet",
                  },
                  requestId: "test",
                },
              },
              attendees: [
                {
                  email: this.user.email,
                  // responseStatus: "accepted",
                },
                {
                  email: this.get_volbyid.userId.email,
                },
              ],
              description: "Description",
              summary: "Caregiver Volunteer Session",
            },
            {
              headers: {
                Authorization: `Bearer ${this.googleAuth.access_token}`, //access_token is gToken
                accept: "application/json",
              },
            }
          );
          // console.log(data);
          this.meetLink = data.hangoutLink;
          // console.log(this.meetLink, " : Google meet Link");

          await Swal.fire({
            title: "Order Placed!",
            text: "Your session has been set Successfully!",
            icon: "success",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          }).then((e) => {
            this.$router.push("care-assistance");
          });
          resolve(data);
          // loader.hide();
        } catch (error) {
          // loader.hide();
          reject(error);
          console.log(error);
        }
      });
    },
    async getToken(code) {
      try {
        let data = await this.$store.dispatch("google/getToken", {
          redirectURL: this.$webURL + "/schedule-page",
          code: code,
        });
        if (data.code === 200) {
          this.$store.commit("google/SET_GOOGLE_AUTH", {
            access_token: data.data,
            scope: decodeURIComponent(this.$route.query.scope),
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onSuccessPayment() {
      // console.log(this.calendarData, "/////// ");
      let payload = {
        volunteerId: this.get_volbyid._id,
        date: this.calendarData.selectedDate,
        time: this.selectedTime,
      };
      try {
        let data = await this.$store.dispatch(
          "respitecare/editvolunteer",
          payload
        );
        this.$bvModal.show("modal-6");
      } catch (error) {}
    },
  },
  watch: {
    selected(newVal, oldVal) {
      // console.log(this.selected);
      if (this.selected === "online") {
        if (this.isGoogleSigned == "true" || this.$route.query.code) {
        } else {
          this.getAuth();
        }
      }
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_volbyid: "get_volbyid",
      get_volunteerbooking: "get_volunteerbooking",
    }),
    ...mapState("eLearning", {
      profileData: "profileData",
    }),
    ...mapState("auth", {
      user: "user",
    }),
  },
  computed: {
    ...mapState("respitecare", {
      get_volbyid: "get_volbyid",
    }),
    ...mapState("eLearning", {
      profileData: "profileData",
    }),
    ...mapState("auth", {
      user: "user",
    }),
    ...mapState("auth", ["sessionPrice"]),
    ...mapState("google", ["googleAuth"]),
  },
  async mounted() {
    // this.init();
    if (this.$route.query.code) {
      this.selected = "online";
    } else {
      this.selected = "in-person";
    }
    // console.log("this.get_volbyid");
    if (this.get_volbyid) {
      this.get_volbyid.dateTimeSlots.map((e) => {
        this.enabledDates.push(e.date);
      });
    }
    this.isGoogleSigned = window.localStorage.getItem("isGoogleSigned");
  },
};
</script>
<style>
.text-535353 {
  color: #535353;
}
.book-button {
  padding: 11px 65px;
  border-radius: 0;
  background: #4f0a4b;
  color: white;
}
.book-button:hover {
  background: #470944 !important;
  color: white !important;

  border-radius: 0;
}
.fsize25px {
  font-size: 25px;
}
.vfc-content {
  z-index: 0;
}
span.vfc-cursor-pointer.vfc-underline {
  font-weight: 600 !important;
}
span.vfc-cursor-pointer.vfc-underline {
  font-weight: 600 !important;
}
.vfc-main-container {
  box-shadow: none;
  background: none;
  border-top: 1px solid #0000001c;
  border-bottom: 0px solid #00000024;
  border-radius: 0px;

  font-family: sans-serif !important;
}
.vfc-marked {
  background-color: #4f0a4b !important;
}
.vfc-selected {
  background-color: #4f0a4b !important;
}
.vfc-week .vfc-day span.vfc-span-day.vfc-marked {
  background-color: #4f0a4b !important;
  color: white !important;
}
.vfc-today {
  border: 1px solid #4f0a4b !important;
  background: #fff !important;
  color: #4f0a4b !important;
}
.vfc-content-MY-picker {
  background-color: white !important;
  color: black !important;
}
.h-100px {
  height: 100px;
}
.modal-title {
  font-size: 1.5rem !important;
  color: #000 !important;
  font-weight: 700 !important;
  line-height: 20px !important;
  padding-top: 7px !important;
}
.modal-header .close {
  padding: 0.5rem 1rem;
  margin: -1rem -1rem -1rem auto;
  color: #000;
  font-size: 40px;
}
</style>
